import styled from 'styled-components/macro';

const SubContainer = styled.div`
  max-width: 600px;
  margin-left: 20px;
  margin-right: 20px;
`;

export default SubContainer;